import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreators from "./actions.js";
import { canManageByApplication } from "orion-components/Profiles/Selectors";
import { evacuationService } from "client-app-core";
import { simpleUnsub } from "../../ContextualData/contextStreaming/index.js";

const EvacuationAccountabilityService = () => {
	const dispatch = useDispatch();
	const { subscribeProcedureUpdates } = actionCreators;
	const procedureId = useSelector((state) => state?.evacuationAccountability?.procedureId);
	const appAccess = useSelector((state) =>
		canManageByApplication(state, "evacuation-accountability-app", "canView", "config")
	);
	const subscriptionChannel = useSelector((state) => state?.evacuationAccountability?.subscriptionChannel) ?? null;

	//This useEffect is called only once when the app initially loads to check if there is an active procedure and then subscribes to the stream.
	useEffect(() => {
		if (appAccess) {
			evacuationService.checkProcedureStatus((err, result) => {
				if (err) {
					console.error("Unable to find procedure status", err);
					return;
				}
				if (result?.isProcedureActive) {
					dispatch(subscribeProcedureUpdates());
				}
			});
		}
	}, [appAccess]);

	// This useEffect is responsible for creating a new subscription when the existing one is closed by the reset evacuation procedure.
	useEffect(() => {
		if (procedureId) {
			if (subscriptionChannel) simpleUnsub(subscriptionChannel);
			dispatch(subscribeProcedureUpdates());
		}
	}, [procedureId]);

	return <Fragment />;
};

export default EvacuationAccountabilityService;
